import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

/**
 * FloatingOrbs — soft animated background orbs that keep drifting.
 * Pure presentational. Place behind hero/sections via z-index.
 */
const FloatingOrbs = ({ count = 5, palette = ['#FF6B4A', '#FBBF24', '#38BDF8', '#A78BFA', '#34D399'], blur = 110 }) => {
  const orbs = useMemo(() => Array.from({ length: count }).map((_, i) => ({
    color: palette[i % palette.length],
    size: 280 + Math.random() * 200,
    startX: Math.random() * 100,
    startY: Math.random() * 100,
    dx: 30 + Math.random() * 60,
    dy: 30 + Math.random() * 60,
    delay: i * 0.7,
    duration: 12 + Math.random() * 10,
    opacity: 0.18 + Math.random() * 0.18,
  })), [count, palette]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {orbs.map((o, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full"
          style={{
            background: o.color,
            width: o.size,
            height: o.size,
            left: `${o.startX}%`,
            top: `${o.startY}%`,
            filter: `blur(${blur}px)`,
            opacity: o.opacity,
            willChange: 'transform',
          }}
          animate={{
            x: [0, o.dx, -o.dx / 2, 0],
            y: [0, -o.dy, o.dy / 2, 0],
            scale: [1, 1.15, 0.92, 1],
          }}
          transition={{
            duration: o.duration,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: o.delay,
          }}
        />
      ))}
    </div>
  );
};

export default FloatingOrbs;
